import { Controller } from "@hotwired/stimulus"

// Native details handles toggle/keyboard semantics; this adds light-dismiss behavior.
export default class extends Controller {
  static targets = ["trigger"]

  outside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  escape(event) {
    if (!this.element.open) return
    event.preventDefault()
    this.close()
    this.triggerTarget.focus()
  }

  close() { this.element.open = false }
  disconnect() { this.close() }
}
